<script setup>
  import ProForecastHeader from '@/components/ProForecastHeader.vue';
  import ProForecastBodyDaily from '@/components/ProForecastBodyDaily.vue';
  import ProForecastBodyNextUpdateMessage from '@/components/ProForecastBodyNextUpdateMessage.vue';
  import ProForecastFooter from '@/components/ProForecastFooter.vue';
  import ProForecastCredits from '@/components/ProForecastCredits.vue';

  const emit = defineEmits(['accordian:toggle', 'settings:change', 'state:change']);

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    hasExtendedForecast: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    forecaster: {
      type: Object,
      default: null
    },
    showDailyForecast: {
      type: Boolean,
      default: false
    },
    spotForecastSettings: {
      type: Object,
      default: null
    },
    spotForecastState: {
      type: Object,
      required: false
    },
    spotForecastStateLoading: {
      type: Boolean,
      default: false
    }
  });

  const handleAccordianToggle = (e) => {
    emit('accordian:toggle', e);
  }

  const handleStateChange = (newState) => {
    emit('state:change', newState);
  }

  const handleSettingsChange = (newSettings) => {
    emit('settings:change', newSettings);
  }

</script>

<template>
  <ProForecastHeader 
    v-if="showHeader" 
    :proForecast="props.proForecast" 
    :forecaster="props.forecaster"
  />
  <ProForecastBodyDaily 
    v-if="props.showDailyForecast" 
    :proForecast="props.proForecast" 
    :spotForecastState="props.spotForecastState"
    :spotForecastSettings="props.spotForecastSettings"
    :forecaster="props.forecaster"
    :showDailyForecast="props.showDailyForecast"
    @accordian:toggle="handleAccordianToggle"
    @state:change="handleStateChange"
    @settings:change="handleSettingsChange"
  />
  <ProForecastFooter v-if="props.showDailyForecast && props.hasExtendedForecast" :proForecast="props.proForecast" :midFooter="true" />
  <ProForecastBodyNextUpdateMessage v-if="!props.showDailyForecast" :validDate="props.proForecast.valid_time_local_formatted" :timezone="props.proForecast.tz_name_short" />
</template>